module.exports = __webpack_public_path__ + "static/IMG_1754-4f9de232c0a3a45a8eab63366f02220a.png";